import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      // Set user data
      setUser: (user) => set({ user, isAuthenticated: true }),

      // Set token
      setToken: (token) => set({ token }),

      // Login
      login: (user, token) => {
        localStorage.setItem("isApplicant", token);
        localStorage.setItem("isApplicantData", JSON.stringify(user));
        set({ user, token, isAuthenticated: true });
      },

      // Logout
      logout: () => {
        localStorage.clear();
        set({ user: null, token: null, isAuthenticated: false });
      },

      // Get user
      getUser: () => get().user,

      // Check if authenticated
      checkAuth: () => {
        const token = localStorage.getItem("isApplicant");
        const userData = localStorage.getItem("isApplicantData");

        if (token && userData) {
          try {
            const user = JSON.parse(userData);
            set({ user, token, isAuthenticated: true });
            return true;
          } catch (error) {
            return false;
          }
        }
        return false;
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated
      }),
    }
  )
);

export default useAuthStore;
